<template lang="pug">
#BusinessGroupView.custom-container.pb-3
  .section-title Detalle Grupo
  b-breadcrumb.breadcrumb(:items="breadcrumbs")
  .table-view.pb-3
    h3.detail-title Editar Grupo {{ businessGroup ? businessGroup.name : '' }}
    hr
    b-container(fluid)
      GroupForm(editMode)
    ListBusinessByGroup
</template>
<script>
import GroupForm from "../components/business_group/GroupForm";
import ListBusinessByGroup from '../components/business_group/ListBusinessByGroup.vue'
import { mapGetters } from 'vuex'
export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Grupos de Empresas',
          to: { name: 'BusinessGroup' }
        },
        {
          text: 'Detalle Grupo',
          active:true
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['businessGroup'])
  },
  components: {
    GroupForm,
    ListBusinessByGroup
  },
};
</script>
